import { UserOutlined } from '@ant-design/icons-vue';
import { AUTH_KEYS } from '@/constants';
import Layout from '@/layout/Layout.vue';

export default {
  path: '/inquiry-admin',
  component: Layout,
  name: 'InquiryAdminParent',
  meta: { title: 'Contact us (Administrator)', root: true, auth: AUTH_KEYS.INQUIRY_ADMIN },
  children: [
    {
      path: '',
      name: 'InquiryAdmin',
      component: () => import('@/views/Inquiry/Inquiry.vue'),
      meta: {
        title: 'Contact us (Administrator)',
        isAdminInquiry: true,
        isHide: true
      }
    }
  ]
};
